import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosError, AxiosResponse } from 'axios'

export type PdvsResponse = {
  pdvs: {
    id: number
    name: string
  }[]
  ocasioes: {
    id: number
    name: string
  }[]
}

export interface useEventPDVsProps {
  accessSumary: PdvsResponse
  accessSumaryLoading: boolean
  accessSumaryError: AxiosError
  accessSumaryRender: string
}

type Status = 'loading' | 'error' | 'success' | 'idle'

export function getStatus<T>(
  data: T | undefined,
  error: any | undefined,
  isLoading: boolean
): Status {
  if (error !== undefined) {
    return 'error'
  }
  if (isLoading) {
    return 'loading'
  }
  if (data !== undefined) {
    return 'success'
  }
  return 'idle'
}

export interface useValidationProps {
  fetcher: (id: any) => Promise<any>
}

export const useAccessSumaryV2 = (type: string = 'access'): useValidationProps => {
  const url = `/producer/analytics/getAccessSumary?type=${type}`
  const fetcher = async (entrada: any): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().post(url, entrada)
  }

  return {
    fetcher,
  }
}
